import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as ProductoService from 'services/producto.service'

import { NuevoActualizarProductoForm } from 'sharedComponents/forms'

import { IdGen } from 'utils'

const NuevoActualizarPage = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)

  const editarDataRef = React.useRef({})

  const portletBreadcrumbs = React.useMemo(() => {
    if (match.params.id) {
      return [{ name: 'Productos', path: `/${CodigosTransaccionesConstant.PRODUCTOS_LISTA}` }, { name: 'Editar' }]
    }
    return [{ name: 'Productos', path: `/${CodigosTransaccionesConstant.PRODUCTOS_LISTA}` }, { name: 'Nuevo' }]
  }, [match.params.id])

  React.useEffect(() => {
    if (match.params.id) {
      ProductoService.getProducto(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [match.params, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='PRODUCTOS' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        {__keyMainForm && (
          <NuevoActualizarProductoForm
            key={__keyMainForm}
            editarData={editarDataRef.current}
            flagEdicion={!!match.params.id}
          />
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoActualizarPage)
